const state = {
  categories: [],
  specificCategory: {},
  filteringPolicy: null,
};

const getters = {
  defaultCategories: (state) => state.categories,
  defaultSpecificCategory: (state) => state.specificCategory,
  defaultFilteringPolicy: (state) => state.filteringPolicy,
  lowLevelCategories: (state) =>
    (state.categories = state.categories.map((category) => {
      category.allowed = true;
      if (category.level === "L") {
        category.allowed = false;
      }
      return category;
    })),
  moderateLevelCategories: (state) =>
    (state.categories = state.categories.map((category) => {
      category.allowed = true;
      if (category.level === "L" || category.level === "M") {
        category.allowed = false;
      }
      return category;
    })),
  highLevelCategories: (state) =>
    (state.categories = state.categories.map((category) => {
      category.allowed = true;
      if (
        category.level === "L" ||
        category.level === "M" ||
        category.level === "H"
      ) {
        category.allowed = false;
      }
      return category;
    })),
};

const actions = {
  async fetchDefaultPolicyCategories(
    { commit },
    { mspId = null, userId = null }
  ) {
    const response = await this._vm.$http.get(
      mspId != null
        ? `/restapi/policies/default/categories?msp_id=${mspId}`
        : userId != null
        ? `/restapi/policies/default/categories?user_id=${userId}`
        : `/restapi/policies/default/categories`
    );
    commit("setCategories", response.data);
  },

  async fetchDefaultSpecificPolicyCategories(
    { commit },
    { categoryId, mspId = null }
  ) {
    const response = await this._vm.$http.get(
      mspId != null
        ? `/restapi/policies/default/categories/${categoryId}?msp_id=${mspId}`
        : `/restapi/policies/default/categories/${categoryId}`
    );

    commit("setSpecificCategories", response.data);
  },

  async fetchDefaultFilteringPolicy({ commit }, { mspId = null }) {
    const response = await this._vm.$http.get(
      mspId != null
        ? `/restapi/policies/default?msp_id=${mspId}`
        : `/restapi/policies/default`
    );

    commit("setFilteringPolicy", response.data);
  },

  async updateDefaultPolicyCategories(
    { commit },
    { categories, mspId = null }
  ) {
    const response = await this._vm.$http.post(
      mspId != null
        ? `/restapi/policies/default/categories/?msp_id=${mspId}`
        : `/restapi/policies/default/categories/`,
      categories
    );
    commit("updateCategories", response.data);
  },

  async updateDefaultSpecificCategory(
    { commit },
    { categoryId, category, mspId = null }
  ) {
    const response = await this._vm.$http.put(
      mspId != null
        ? `/restapi/policies/default/categories/${categoryId}?msp_id=${mspId}`
        : `/restapi/policies/default/categories/${categoryId}`,
      category
    );
    commit("updateSpecificCategory", response.data);
  },

  async updateDefaultFilteringPolicy(
    { commit },
    { defaultPolicy, mspId = null }
  ) {
    const response = await this._vm.$http.put(
      mspId != null
        ? `/restapi/policies/default?msp_id=${mspId}`
        : `/restapi/policies/default`,
      defaultPolicy
    );
    commit("updateDefaultFilteringPolicy", response.data);
  },

  // eslint-disable-next-line no-unused-vars
  async updateRegategorizeDomains({ commit }, { body }) {
    const response = await this._vm.$http.post(
      `/restapi/tools/recategorize`,
      body
    );
    return response.data;
  },
};

const mutations = {
  setCategories: (state, data) => (state.categories = data.data),
  setSpecificCategories: (state, data) => (state.specificCategory = data),
  setFilteringPolicy: (state, data) => (state.filteringPolicy = data),
  updateCategories: (state, data) =>
    (state.categories = state.categories.map((category) => {
      if (category.id === data.id) return { ...category, ...data };
      return category;
    })),
  updateSpecificCategory: (state, data) => (state.specificCategory = data),
  updateDefaultFilteringPolicy: (state, data) => (state.filteringPolicy = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
